import { CognitoUserPool, AuthenticationDetails, CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js'
import Vue from 'vue'
import axios from 'axios'
import _ from 'underscore'

function getUserPool () {
  const poolData = {
    UserPoolId: process.env.COGNITO_USER_POOL_ID,
    ClientId: process.env.COGNITO_CLIENT_ID
  }
  const userPool = new CognitoUserPool(poolData)
  return userPool
}

function userAttribute (name, value) {
  return new CognitoUserAttribute({
    Name: name,
    Value: value
  })
}
function getUserAttributes (email, accountType, name, phone) {
  const attributeList = []
  attributeList.push(userAttribute('email', email))
  attributeList.push(userAttribute('nickname', accountType))
  attributeList.push(userAttribute('name', name))
  attributeList.push(userAttribute('phone_number', phone))
  return attributeList
}

function internalUpdateUser (oldUser, newUser) {
  Vue.set(oldUser, 'id', newUser.id)
  Vue.set(oldUser, 'name', newUser.name)
  Vue.set(oldUser, 'email', newUser.email)
  Vue.set(oldUser, 'roles', newUser.roles)
  Vue.set(oldUser, 'address', newUser.address)
  Vue.set(oldUser, 'phone', newUser.phone)
  Vue.set(oldUser, 'balance', newUser.balance)
  Vue.set(oldUser, 'credit', newUser.credit)
  Vue.set(oldUser, 'online', newUser.online)
  Vue.set(oldUser, 'isAdmin', newUser.roles && newUser.roles.indexOf('admin') !== -1)
  Vue.set(oldUser, 'isCourier', newUser.roles && newUser.roles.indexOf('courier') !== -1)
  Vue.set(oldUser, 'isStore', newUser.roles && newUser.roles.indexOf('store') !== -1)
  Vue.set(oldUser, 'isRequester', newUser.roles && newUser.roles.indexOf('requester') !== -1)
  Vue.set(oldUser, 'isProxy', newUser.roles && newUser.roles.indexOf('proxy') !== -1)
}

export default ({
  user: {},
  register: function (email, password, accountType, name, phone, success, failure) {
    const attributeList = getUserAttributes(email, accountType, name, phone)
    getUserPool().signUp(email, password, attributeList, null, function (err, result) {
      if (err) {
        console.error('Sign up failed', err)
        if (typeof failure === 'function') {
          failure(err)
        }
      } else {
        const cognitoUser = result.user
        console.log('user name is ' + cognitoUser.getUsername())
        if (typeof success === 'function') {
          success(cognitoUser)
        }
      }
    })
  },

  login: function (email, password, success, failure) {
    const v = this
    const authenticationData = {
      Username: email,
      Password: password
    }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    const userPool = getUserPool()
    const userData = {
      Username: email,
      Pool: userPool
    }
    const cognitoUser = new CognitoUser(userData)
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        v.getCurrentUser()
        if (typeof success === 'function') {
          success()
        }
      },
      onFailure: function (err) {
        if (typeof failure === 'function') {
          failure(err)
        }
      },
      newPasswordRequired: function (userAttributes, requiredAttributes) {
        delete userAttributes.email_verified
        cognitoUser.completeNewPasswordChallenge(password, userAttributes, this)
      }
    })
  },

  logout: function () {
    const cognitoUser = getUserPool().getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.signOut()
    }
    internalUpdateUser(this.user, {})
  },

  isAuthenticated: function () {
    const authenticated = getUserPool().getCurrentUser() != null
    return authenticated
  },

  isAdmin: async function () {
    let user = await this.getUser()
    return user.roles && user.roles.indexOf('admin') !== -1
  },

  getCurrentUser: function () {
    this.getUser().then((user) => {
      internalUpdateUser(this.user, user)
    })
    return this.user
  },

  getCurrentSessionPromise: function () {
    const promise = new Promise(function (resolve, reject) {
      const cognitoUser = getUserPool().getCurrentUser()
      if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
          if (err) {
            reject(err)
          }
          resolve(session)
        })
      } else {
        throw new Error('not authenticated')
      }
    })
    return promise
  },

  getUser: _.throttle(function () {
    if (!this.isAuthenticated()) {
      return Promise.resolve({})
    }
    return new Promise(function (resolve, reject) {
      axios
        .get(process.env.BASE_URL + '/me')
        .then(response => {
          response.data.user.roles = response.data.user.roles ? response.data.user.roles.split(',') : []
          resolve(response.data.user)
        }, () => {
          resolve({})
        })
    })
  }, 5000),

  verify: function (email, code, successCallback, errorCallback) {
    const userPool = getUserPool()
    const userData = {
      Username: email,
      Pool: userPool
    }
    var cognitoUser = new CognitoUser(userData)
    cognitoUser.confirmRegistration(code, true, function (err, result) {
      if (err) {
        errorCallback(err)
        return
      }
      successCallback(result)
    })
  },

  requestResetPassword: function (email, successCallback, errorCallback) {
    const userPool = getUserPool()
    const userData = {
      Username: email,
      Pool: userPool
    }
    var cognitoUser = new CognitoUser(userData)
    cognitoUser.forgotPassword({
      onSuccess: function (data) {
        console.log('Email with code is sent on the email')
        successCallback()
      },
      onFailure: function (err) {
        console.log('Reset password process is failed')
        console.log(err)
        errorCallback(err)
      }
    })
  },

  resetPassword: function (email, verificationCode, newPassword, successCallback, errorCallback) {
    const userPool = getUserPool()
    const userData = {
      Username: email,
      Pool: userPool
    }
    var cognitoUser = new CognitoUser(userData)
    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onSuccess (result) {
        console.log('Password confirmed!')
        successCallback()
      },
      onFailure (err) {
        console.log('Password not confirmed! ' + err)
        errorCallback(err)
      }
    })
  },

  changePassword: function (email, oldPassword, newPassword, successCallback, errorCallback) {
    const userPool = getUserPool()
    var cognitoUser = userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        if (err) {
          errorCallback(err)
          return
        }
        cognitoUser.changePassword(oldPassword, newPassword, function (err, result) {
          if (err) {
            errorCallback(err)
            return
          }
          successCallback(result)
        })
      })
    }
  }
})
